import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../../unit/index";
import nProgress from "nprogress";
import { setRedirectUrl } from "../../unit/index";
import "nprogress/nprogress.css";

const PrivateRoute = (props) => {
  useEffect(() => {
    nProgress.done();
    return () => nProgress.start();
  });
  const { children } = props;
  // 判断是否登录
  if (!getToken()) {
    setRedirectUrl(window.location.href);
    document.title = "登录-" + (localStorage.getItem("web_title"));
  } else {
    if (props.menu_name) {
      document.title = `${props.menu_name}-` + (localStorage.getItem("web_title"));
    }
  }
  return getToken() ? (
    // 如果是登录用户，则可以访问我们传入的 children 组件
    <>{children}</>
  ) : (
    // 未登录用户重定向到 login 页面
    <Navigate replace={true} to={`/login?next_url=${window.location.href}`} />
  );
};

export default PrivateRoute;
